/**
 * Generated by orval v7.1.1 🍺
 * Do not edit manually.
 * shortsworks
 * 

#ShortsWorksAPIDocs

##버전

헤더에그룹화된태그를추가하는방식으로버저닝을지원합니다.

예시)
```

GET{{host}}/account/signin
headers=[
...
{"x-api-version":"2024-09-01"},
...
]

```

버전리스트
***2024-09-01**(version을적지않으면기본적용되는버전)
***2024-10-16**


 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  CommonResponseDto,
  CreateWidgetRequestDto,
  GetWidgetDetailsParams,
  HTTPValidationError,
  SuccessOrErrorResponse,
  UpdateWidgetGroupsRequestDto,
  UpdateWidgetProductsRequestDto,
  UpdateWidgetRequestDto,
  UpdateWidgetStoriesRequestDto,
  WidgetDetailsResponseDto,
  WidgetResponseDto,
  WidgetSettingsResponseDto,
  WidgetsResponseDto
} from '.././model'
import { client } from '../../lib/client';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * 엑세스키의계정에서가지고있는위젯들을전부가져오는API
 * @summary GetWidgets
 */
export const getWidgets = (
    
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<WidgetsResponseDto>(
      {url: `/widget/`, method: 'GET', signal
    },
      options);
    }
  

export const getGetWidgetsQueryKey = () => {
    return [`/widget/`] as const;
    }

    
export const getGetWidgetsQueryOptions = <TData = Awaited<ReturnType<typeof getWidgets>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWidgets>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWidgetsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWidgets>>> = ({ signal }) => getWidgets(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWidgets>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWidgetsQueryResult = NonNullable<Awaited<ReturnType<typeof getWidgets>>>
export type GetWidgetsQueryError = HTTPValidationError


export function useGetWidgets<TData = Awaited<ReturnType<typeof getWidgets>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWidgets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWidgets>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetWidgets<TData = Awaited<ReturnType<typeof getWidgets>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWidgets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWidgets>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetWidgets<TData = Awaited<ReturnType<typeof getWidgets>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWidgets>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetWidgets
 */

export function useGetWidgets<TData = Awaited<ReturnType<typeof getWidgets>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWidgets>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWidgetsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetWidgetsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getWidgets>>, TError = HTTPValidationError>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWidgets>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWidgetsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWidgets>>> = ({ signal }) => getWidgets(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWidgets>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWidgetsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getWidgets>>>
export type GetWidgetsSuspenseQueryError = HTTPValidationError


export function useGetWidgetsSuspense<TData = Awaited<ReturnType<typeof getWidgets>>, TError = HTTPValidationError>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWidgets>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetWidgetsSuspense<TData = Awaited<ReturnType<typeof getWidgets>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWidgets>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetWidgetsSuspense<TData = Awaited<ReturnType<typeof getWidgets>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWidgets>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetWidgets
 */

export function useGetWidgetsSuspense<TData = Awaited<ReturnType<typeof getWidgets>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWidgets>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWidgetsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 위젯생성API
 * @summary CreateWidget
 */
export const createWidget = (
    createWidgetRequestDto: CreateWidgetRequestDto,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<SuccessOrErrorResponse>(
      {url: `/widget/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createWidgetRequestDto
    },
      options);
    }
  


export const getCreateWidgetMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWidget>>, TError,{data: CreateWidgetRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof createWidget>>, TError,{data: CreateWidgetRequestDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWidget>>, {data: CreateWidgetRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  createWidget(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateWidgetMutationResult = NonNullable<Awaited<ReturnType<typeof createWidget>>>
    export type CreateWidgetMutationBody = CreateWidgetRequestDto
    export type CreateWidgetMutationError = HTTPValidationError

    /**
 * @summary CreateWidget
 */
export const useCreateWidget = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWidget>>, TError,{data: CreateWidgetRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof createWidget>>,
        TError,
        {data: CreateWidgetRequestDto},
        TContext
      > => {

      const mutationOptions = getCreateWidgetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 계정의단일위젯을가져오는API
 * @summary GetWidget
 */
export const getWidget = (
    widgetId: string,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<WidgetResponseDto>(
      {url: `/widget/${widgetId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetWidgetQueryKey = (widgetId: string,) => {
    return [`/widget/${widgetId}`] as const;
    }

    
export const getGetWidgetQueryOptions = <TData = Awaited<ReturnType<typeof getWidget>>, TError = HTTPValidationError>(widgetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWidget>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWidgetQueryKey(widgetId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWidget>>> = ({ signal }) => getWidget(widgetId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(widgetId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWidget>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWidgetQueryResult = NonNullable<Awaited<ReturnType<typeof getWidget>>>
export type GetWidgetQueryError = HTTPValidationError


export function useGetWidget<TData = Awaited<ReturnType<typeof getWidget>>, TError = HTTPValidationError>(
 widgetId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWidget>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWidget>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetWidget<TData = Awaited<ReturnType<typeof getWidget>>, TError = HTTPValidationError>(
 widgetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWidget>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWidget>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetWidget<TData = Awaited<ReturnType<typeof getWidget>>, TError = HTTPValidationError>(
 widgetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWidget>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetWidget
 */

export function useGetWidget<TData = Awaited<ReturnType<typeof getWidget>>, TError = HTTPValidationError>(
 widgetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWidget>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWidgetQueryOptions(widgetId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetWidgetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getWidget>>, TError = HTTPValidationError>(widgetId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWidget>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWidgetQueryKey(widgetId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWidget>>> = ({ signal }) => getWidget(widgetId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(widgetId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWidget>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWidgetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getWidget>>>
export type GetWidgetSuspenseQueryError = HTTPValidationError


export function useGetWidgetSuspense<TData = Awaited<ReturnType<typeof getWidget>>, TError = HTTPValidationError>(
 widgetId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWidget>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetWidgetSuspense<TData = Awaited<ReturnType<typeof getWidget>>, TError = HTTPValidationError>(
 widgetId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWidget>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetWidgetSuspense<TData = Awaited<ReturnType<typeof getWidget>>, TError = HTTPValidationError>(
 widgetId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWidget>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetWidget
 */

export function useGetWidgetSuspense<TData = Awaited<ReturnType<typeof getWidget>>, TError = HTTPValidationError>(
 widgetId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWidget>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWidgetSuspenseQueryOptions(widgetId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 위젯수정API
 * @summary PutWidget
 */
export const putWidget = (
    widgetId: string,
    updateWidgetRequestDto: UpdateWidgetRequestDto,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<SuccessOrErrorResponse>(
      {url: `/widget/${widgetId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateWidgetRequestDto
    },
      options);
    }
  


export const getPutWidgetMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putWidget>>, TError,{widgetId: string;data: UpdateWidgetRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof putWidget>>, TError,{widgetId: string;data: UpdateWidgetRequestDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putWidget>>, {widgetId: string;data: UpdateWidgetRequestDto}> = (props) => {
          const {widgetId,data} = props ?? {};

          return  putWidget(widgetId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutWidgetMutationResult = NonNullable<Awaited<ReturnType<typeof putWidget>>>
    export type PutWidgetMutationBody = UpdateWidgetRequestDto
    export type PutWidgetMutationError = HTTPValidationError

    /**
 * @summary PutWidget
 */
export const usePutWidget = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putWidget>>, TError,{widgetId: string;data: UpdateWidgetRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof putWidget>>,
        TError,
        {widgetId: string;data: UpdateWidgetRequestDto},
        TContext
      > => {

      const mutationOptions = getPutWidgetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 위젯삭제API
 * @summary DeleteWidget
 */
export const deleteWidget = (
    widgetId: string,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<SuccessOrErrorResponse>(
      {url: `/widget/${widgetId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteWidgetMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWidget>>, TError,{widgetId: string}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteWidget>>, TError,{widgetId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWidget>>, {widgetId: string}> = (props) => {
          const {widgetId} = props ?? {};

          return  deleteWidget(widgetId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteWidgetMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWidget>>>
    
    export type DeleteWidgetMutationError = HTTPValidationError

    /**
 * @summary DeleteWidget
 */
export const useDeleteWidget = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWidget>>, TError,{widgetId: string}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteWidget>>,
        TError,
        {widgetId: string},
        TContext
      > => {

      const mutationOptions = getDeleteWidgetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 계정의단일위젯의세팅정보를가져오는API
 * @summary GetWidgetSettings
 */
export const getWidgetSettings = (
    widgetId: string,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<WidgetSettingsResponseDto>(
      {url: `/widget/${widgetId}/settings`, method: 'GET', signal
    },
      options);
    }
  

export const getGetWidgetSettingsQueryKey = (widgetId: string,) => {
    return [`/widget/${widgetId}/settings`] as const;
    }

    
export const getGetWidgetSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getWidgetSettings>>, TError = HTTPValidationError>(widgetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWidgetSettings>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWidgetSettingsQueryKey(widgetId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWidgetSettings>>> = ({ signal }) => getWidgetSettings(widgetId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(widgetId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWidgetSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWidgetSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getWidgetSettings>>>
export type GetWidgetSettingsQueryError = HTTPValidationError


export function useGetWidgetSettings<TData = Awaited<ReturnType<typeof getWidgetSettings>>, TError = HTTPValidationError>(
 widgetId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWidgetSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWidgetSettings>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetWidgetSettings<TData = Awaited<ReturnType<typeof getWidgetSettings>>, TError = HTTPValidationError>(
 widgetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWidgetSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWidgetSettings>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetWidgetSettings<TData = Awaited<ReturnType<typeof getWidgetSettings>>, TError = HTTPValidationError>(
 widgetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWidgetSettings>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetWidgetSettings
 */

export function useGetWidgetSettings<TData = Awaited<ReturnType<typeof getWidgetSettings>>, TError = HTTPValidationError>(
 widgetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWidgetSettings>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWidgetSettingsQueryOptions(widgetId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetWidgetSettingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getWidgetSettings>>, TError = HTTPValidationError>(widgetId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWidgetSettings>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWidgetSettingsQueryKey(widgetId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWidgetSettings>>> = ({ signal }) => getWidgetSettings(widgetId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(widgetId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWidgetSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWidgetSettingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getWidgetSettings>>>
export type GetWidgetSettingsSuspenseQueryError = HTTPValidationError


export function useGetWidgetSettingsSuspense<TData = Awaited<ReturnType<typeof getWidgetSettings>>, TError = HTTPValidationError>(
 widgetId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWidgetSettings>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetWidgetSettingsSuspense<TData = Awaited<ReturnType<typeof getWidgetSettings>>, TError = HTTPValidationError>(
 widgetId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWidgetSettings>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetWidgetSettingsSuspense<TData = Awaited<ReturnType<typeof getWidgetSettings>>, TError = HTTPValidationError>(
 widgetId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWidgetSettings>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetWidgetSettings
 */

export function useGetWidgetSettingsSuspense<TData = Awaited<ReturnType<typeof getWidgetSettings>>, TError = HTTPValidationError>(
 widgetId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWidgetSettings>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWidgetSettingsSuspenseQueryOptions(widgetId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 위젯의그룹정보를업데이트하는API
 * @summary UpdateWidgetGroups
 */
export const updateWidgetGroups = (
    widgetId: string,
    updateWidgetGroupsRequestDto: UpdateWidgetGroupsRequestDto,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<CommonResponseDto>(
      {url: `/widget/${widgetId}/groups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateWidgetGroupsRequestDto
    },
      options);
    }
  


export const getUpdateWidgetGroupsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWidgetGroups>>, TError,{widgetId: string;data: UpdateWidgetGroupsRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof updateWidgetGroups>>, TError,{widgetId: string;data: UpdateWidgetGroupsRequestDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWidgetGroups>>, {widgetId: string;data: UpdateWidgetGroupsRequestDto}> = (props) => {
          const {widgetId,data} = props ?? {};

          return  updateWidgetGroups(widgetId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateWidgetGroupsMutationResult = NonNullable<Awaited<ReturnType<typeof updateWidgetGroups>>>
    export type UpdateWidgetGroupsMutationBody = UpdateWidgetGroupsRequestDto
    export type UpdateWidgetGroupsMutationError = HTTPValidationError

    /**
 * @summary UpdateWidgetGroups
 */
export const useUpdateWidgetGroups = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWidgetGroups>>, TError,{widgetId: string;data: UpdateWidgetGroupsRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateWidgetGroups>>,
        TError,
        {widgetId: string;data: UpdateWidgetGroupsRequestDto},
        TContext
      > => {

      const mutationOptions = getUpdateWidgetGroupsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 위젯의포스팅정보를업데이트하는API
 * @summary UpdateWidgetStories
 */
export const updateWidgetStories = (
    widgetId: string,
    updateWidgetStoriesRequestDto: UpdateWidgetStoriesRequestDto,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<CommonResponseDto>(
      {url: `/widget/${widgetId}/stories`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateWidgetStoriesRequestDto
    },
      options);
    }
  


export const getUpdateWidgetStoriesMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWidgetStories>>, TError,{widgetId: string;data: UpdateWidgetStoriesRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof updateWidgetStories>>, TError,{widgetId: string;data: UpdateWidgetStoriesRequestDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWidgetStories>>, {widgetId: string;data: UpdateWidgetStoriesRequestDto}> = (props) => {
          const {widgetId,data} = props ?? {};

          return  updateWidgetStories(widgetId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateWidgetStoriesMutationResult = NonNullable<Awaited<ReturnType<typeof updateWidgetStories>>>
    export type UpdateWidgetStoriesMutationBody = UpdateWidgetStoriesRequestDto
    export type UpdateWidgetStoriesMutationError = HTTPValidationError

    /**
 * @summary UpdateWidgetStories
 */
export const useUpdateWidgetStories = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWidgetStories>>, TError,{widgetId: string;data: UpdateWidgetStoriesRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateWidgetStories>>,
        TError,
        {widgetId: string;data: UpdateWidgetStoriesRequestDto},
        TContext
      > => {

      const mutationOptions = getUpdateWidgetStoriesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 위젯의상품정보를업데이트하는API
 * @summary UpdateWidgetProducts
 */
export const updateWidgetProducts = (
    widgetId: string,
    updateWidgetProductsRequestDto: UpdateWidgetProductsRequestDto,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<CommonResponseDto>(
      {url: `/widget/${widgetId}/products`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateWidgetProductsRequestDto
    },
      options);
    }
  


export const getUpdateWidgetProductsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWidgetProducts>>, TError,{widgetId: string;data: UpdateWidgetProductsRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof updateWidgetProducts>>, TError,{widgetId: string;data: UpdateWidgetProductsRequestDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWidgetProducts>>, {widgetId: string;data: UpdateWidgetProductsRequestDto}> = (props) => {
          const {widgetId,data} = props ?? {};

          return  updateWidgetProducts(widgetId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateWidgetProductsMutationResult = NonNullable<Awaited<ReturnType<typeof updateWidgetProducts>>>
    export type UpdateWidgetProductsMutationBody = UpdateWidgetProductsRequestDto
    export type UpdateWidgetProductsMutationError = HTTPValidationError

    /**
 * @summary UpdateWidgetProducts
 */
export const useUpdateWidgetProducts = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWidgetProducts>>, TError,{widgetId: string;data: UpdateWidgetProductsRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateWidgetProducts>>,
        TError,
        {widgetId: string;data: UpdateWidgetProductsRequestDto},
        TContext
      > => {

      const mutationOptions = getUpdateWidgetProductsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 계정의단일위젯을가져오는API
 * @summary GetWidgetDetails
 */
export const getWidgetDetails = (
    widgetId: string,
    params: GetWidgetDetailsParams,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<WidgetDetailsResponseDto>(
      {url: `/widget/${widgetId}/details`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetWidgetDetailsQueryKey = (widgetId: string,
    params: GetWidgetDetailsParams,) => {
    return [`/widget/${widgetId}/details`, ...(params ? [params]: [])] as const;
    }

    
export const getGetWidgetDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getWidgetDetails>>, TError = HTTPValidationError>(widgetId: string,
    params: GetWidgetDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWidgetDetails>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWidgetDetailsQueryKey(widgetId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWidgetDetails>>> = ({ signal }) => getWidgetDetails(widgetId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(widgetId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWidgetDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWidgetDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getWidgetDetails>>>
export type GetWidgetDetailsQueryError = HTTPValidationError


export function useGetWidgetDetails<TData = Awaited<ReturnType<typeof getWidgetDetails>>, TError = HTTPValidationError>(
 widgetId: string,
    params: GetWidgetDetailsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWidgetDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWidgetDetails>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetWidgetDetails<TData = Awaited<ReturnType<typeof getWidgetDetails>>, TError = HTTPValidationError>(
 widgetId: string,
    params: GetWidgetDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWidgetDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWidgetDetails>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetWidgetDetails<TData = Awaited<ReturnType<typeof getWidgetDetails>>, TError = HTTPValidationError>(
 widgetId: string,
    params: GetWidgetDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWidgetDetails>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetWidgetDetails
 */

export function useGetWidgetDetails<TData = Awaited<ReturnType<typeof getWidgetDetails>>, TError = HTTPValidationError>(
 widgetId: string,
    params: GetWidgetDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWidgetDetails>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWidgetDetailsQueryOptions(widgetId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetWidgetDetailsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getWidgetDetails>>, TError = HTTPValidationError>(widgetId: string,
    params: GetWidgetDetailsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWidgetDetails>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWidgetDetailsQueryKey(widgetId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWidgetDetails>>> = ({ signal }) => getWidgetDetails(widgetId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(widgetId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWidgetDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWidgetDetailsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getWidgetDetails>>>
export type GetWidgetDetailsSuspenseQueryError = HTTPValidationError


export function useGetWidgetDetailsSuspense<TData = Awaited<ReturnType<typeof getWidgetDetails>>, TError = HTTPValidationError>(
 widgetId: string,
    params: GetWidgetDetailsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWidgetDetails>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetWidgetDetailsSuspense<TData = Awaited<ReturnType<typeof getWidgetDetails>>, TError = HTTPValidationError>(
 widgetId: string,
    params: GetWidgetDetailsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWidgetDetails>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetWidgetDetailsSuspense<TData = Awaited<ReturnType<typeof getWidgetDetails>>, TError = HTTPValidationError>(
 widgetId: string,
    params: GetWidgetDetailsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWidgetDetails>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetWidgetDetails
 */

export function useGetWidgetDetailsSuspense<TData = Awaited<ReturnType<typeof getWidgetDetails>>, TError = HTTPValidationError>(
 widgetId: string,
    params: GetWidgetDetailsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWidgetDetails>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWidgetDetailsSuspenseQueryOptions(widgetId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



